export default {
  install(Vue) {
    Vue.prototype.$handleHttpErrorByStatusCode = function(error, options = {}) {
      const status = error?.status || error?.response?.status;
      const { customMessage, timeout } = options;

      const message = customMessage || error?.response?.data?.message || error?.data?.message || error?.message || this.$t("common.failed");

      const toastOptions = {};
      if (timeout) {
        toastOptions.timeout = timeout;
      }

      if (status >= 500 && status < 600) {
        this.$toast.error(message, toastOptions);
      } else if (status) {
        //statusün var ama 500 değil
        this.$toast.warning(message, toastOptions);
      } else {
        // status yoksa
        this.$toast.error(message, toastOptions);
      }
    };
  },
};
